// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__IYUO5","colBig":"styles_colBig__EBDGc","colSmall":"styles_colSmall__3g79a","shopifyNameWrapper":"styles_shopifyNameWrapper__oScqg"};